// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary-orange: #0E1A2B;
  --color-primary-green: #d1ac72;
  --color-text-dark: #1e2530;
  --color-text-body: #4c5258;
  --color-white: #fff;
  --color-danger: #fd3550;
  --color-info-blue: #037de2;
  --color-link-blue: #0d6efd;
  --color-teal: #0a7674;
  --color-teal-hover: #0d9d9a;
  --color-border-light: #ddd;
  --color-bg-page: #f8f9fb;
  --color-bg-panel: #faf7f2;
  --color-bg-hover: #f8f9fa;
  --color-icon-muted: #6c757d;
  --color-dark-slate: #313a46;

  /* merged: nearly identical to text-dark (#1e2530 vs #1a2332), now shares one source */
  --color-sidebar-bg: #0E1A2B;

  /* merged: nearly identical to dark-slate (#313a46 vs #2d3748), now shares one source */
  --color-sidebar-border: var(--color-dark-slate);

  --color-menu-text: #cbd5e1;
  --color-menu-label: #b0afaf;
  --color-icon-slate: var(--color-white);
  --color-menu-hover-bg: var(--color-sidebar-border);
--color-menu-hover-text: var(--color-white);
--color-menu-active-bg: var(--color-text-dark);
--color-menu-active-text: var(--color-primary-green);
  --color-white-a50: #ffffff50;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: var(--color-white);
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

body {
  background: var(--color-bg-page);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  color: var(--color-text-body);
  letter-spacing: .5px;
  overflow-x: hidden;
}

html {
  overflow: hidden;
}

.wrapper {
  display: flex;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow-x: hidden;
}

.edit {
  margin-right: 5px;
}

.main {
  width: 100%;
  height: calc(100% - 70px);
  margin-top: 45px;
  margin-bottom: 20px;
  margin-left: 290px;
  padding: 1.5rem 1.5rem 0.7rem 1.5rem;
  overflow: auto;
}

.wrapper.toggled .main {
  margin-left: 70px;
}

@media screen and (max-width: 768px) {
  .main{
    margin-left:0px !important;
  }
}

.wrapper.toggled .topbar {
  left: 70px;
}
@media screen and (max-width: 768px) {
  .topbar{
    left:0px !important;
  }
}

.default-btn-color {
  background-color: var(--color-primary-green) !important;
  border-color: var(--color-primary-green) !important;
  color: var(--color-text-dark) !important;
  font-weight: 600;
  font-size: 0.8rem;
  
}

/* .btn-primary {
  background-color: var(--color-primary-green) !important;
	border-color: var(--color-primary-green) !important;
} */

.error-text {
  color: var(--color-danger);
}

.modal-title {
  font-weight: bold;
  font-size: 1.25em;
}

.form-control {
  font-size: 1em;
}

.title-heading {
  font-size: 20px;
  margin-top: 20px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
  padding-left: 5px;
  padding-right: 5px;
}

.datepicker input[readonly] {
  background-color: var(--color-border-light);
}

.add-btn-icon {
  color: var(--color-primary-green);
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}

.edit-btn-icon {
  color: var(--color-info-blue);
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}

.delete-btn-icon {
  color: var(--color-danger);
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}

dt {
  margin-bottom: .5rem;
  font-family: Arial, Helvetica, sans-serif;
  color: black;
}



.top-tab {
  border: none;
  background-color: rgb(238, 234, 234);
  margin: 1px 1px 0px 1px;
  position: relative;
  z-index: 8;
  padding: 5px 20px;
  border-top: 1px solid rgba(0, 0, 0, .125);
  border-right: 1px solid rgba(0, 0, 0, .125);
  border-left: 1px solid rgba(0, 0, 0, .125);
  border-radius: 0.25rem .25rem 0 0;

  transform: translate(0, 1px);
}

.top-tab.selected {
  background-color: var(--color-white);
}

.trackerInfo {
  padding: 10px;
  margin: 20px 0px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.trackerInfo h6 {
  font-weight: bold;
  margin: 5px 0px 20px 0px;
}

.formPage .row .col-md-6 {
  margin-top: 1.5rem
}

.role-permissions-row .col label {
  margin-top: 6px;
  font-size: 1.1rem;
  white-space: nowrap;
}

.role-permissions-row {
  padding: 7px 0 7px 0;
  /* border-bottom: 1px solid #00000050; */
}

.detailsPageHeader {
  position: sticky;
  top: 0;
  background: var(--color-bg-page);
  z-index: 9;
  padding-top: 15px;
  transform: translate(0px, -1.5rem);
  margin-bottom: -1.5rem;
}

@media (max-width: 575.98px) {
  .default-btn-color {
    padding: 10px;
  }
}

dl.row {
  margin-bottom: .3rem;
}

.redirectLink {
  color: var(--color-text-dark);
  text-decoration: none;
}
.redirectLink:hover{
  color:var(--color-primary-orange);
}

.custom-table-view{
  height: 400px;
  overflow: auto;
}
.custom-table{
  padding: 5px;
  border-collapse: collapse;
  width: 100%;
}
.table>:not(:first-child){
  border-top: none !important;
}
.custom-table td, .custom-table th{
  border: 1px solid var(--color-border-light) !important;
  padding: 8px;
}
.custom-table tr:nth-child(even){background-color: #f2f2f2 !important;}

.custom-table tr:hover {background-color: var(--color-border-light) !important;}

.custom-table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color:var(--color-primary-green) !important;
  color: var(--color-white);
}

.custom-table span{
  text-transform:capitalize;
}

.cutImage{
  display: block;
  margin: 0px auto;
  width: 100%;
  /* width: 250px; */
}

.sampleFile{
  position: absolute;
  right: 50px;
}

#download-content .viewHeader {
  font-size: 2.5rem !important;
}

.custom-orange-table td,
.custom-orange-table th,
.custom-orange-table tr,
.custom-orange-table thead,
.custom-orange-table tbody {
  border-color:var(--color-primary-orange) !important;
}

.no-border {
  border-color: transparent !important;
}

.custom-btn {
  float: right;
  font-size: 0.9rem;
  margin-bottom: 10px;;
}

.custom-header {
  background-color: #D1D1E8; /* Change to your desired color */
  color: #000; /* Text color */
  font-weight: bold;
  text-align: center;
  font-size: 0.85rem;
  border: 1px solid var(--color-border-light); /* Optional: Add border */
}

.dash-odd-row {
  background-color: #eff5f8 !important; /* Light blue for odd rows */
  color: #333; /* Text color for odd rows */
}

.dash-even-row {
  background-color: var(--color-white); /* White for even rows */
  color: #333; /* Text color for even rows */
}

.statTile-txt
{
  color:#000 !important;
  font-size: 1rem;
  font-weight: bold;
}

.msg-btn, .msg-btn:hover {
  background-color: transparent !important;
  border-color: transparent !important;
  color: var(--color-primary-orange);
  font-size: 2rem;
}

.dropdown-custom .dropdown-item:hover {
  background-color: #444444	 !important; /* Highlight color on hover */
  color: rgb(214, 212, 212) !important; /* Optional: make text readable */
}
.notification-preview * {
  margin: 0;
  padding: 0;
  line-height: 1.5;
}

.notification-preview p {
  margin: 0 0 10px;
}

.notification-preview img {
  display: block;
  /* vertical-align: middle; */
  max-width: 100%;
  height: auto;
}
/* Make the actual Quill container resizable */
.editor-container .ql-container {
  min-height: 180px;
  max-height: 600px;
  resize: vertical;   /* native expand/collapse handle */
  overflow: auto;     /* scrollbar only when needed */
  border: 1px solid var(--color-border-light);
  background: var(--color-white);
}

/* Let editor grow inside */
.editor-container .ql-editor {
  min-height: 150px;
  height: auto;
  overflow-y: auto;
}

/* Keep images responsive inside */
.editor-container .ql-editor img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0;
}

/* Keep heading flush to the left */
.notification-heading {
  text-align: center;
  color:#000;  
  margin-bottom: 6px;
  font-weight: 600;
}

/* Indent content slightly to the right */
.notification-preview {
  padding-left: 20px; 
}

/* Fine-tune inner content */
.notification-preview p,
.notification-preview div {
  margin: 2px 0 !important; /* reduce vertical gaps */
}

.notification-preview img,
.notification-preview video {
  margin-top: 4px;
}

.preview-btn-color {
  background-color: var(--color-primary-orange) !important;
  border-color: var(--color-primary-orange) !important;
  color: var(--color-white) !important;
}

/* date alignment issue fix */
.datepicker .react-datepicker-wrapper {
  width: 100%;
}

/* Ticketing sys */
.ticketing-link {
  background: var(--color-teal);
  color: var(--color-white);
  padding: 3px 12px;
  border-radius: 5px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0 2px 8px rgba(10, 118, 116, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  /* position: relative; */
}

.ticketing-link:hover {
  background: var(--color-teal-hover);
  box-shadow: 0 4px 20px rgba(10, 118, 116, 0.5), 
              0 0 20px rgba(10, 118, 116, 0.3);
  transform: translateY(-2px);
}

.question-tabs{
  border: 1px solid var(--color-primary-orange);
  border-radius: 4px;
  color: #000;
  transition: all 0.1s ease;
  box-shadow: none !important;
}

.question-tabs-selected{
  background-color: var(--color-primary-orange);
  color: var(--color-white);
  box-shadow: none !important;
}

.question-tabs-selected:hover {
  color: var(--color-white);
}

.question-tabs:hover {
  border-color: var(--color-primary-orange);
  background-color: #fff7ed;
  color: #000;
}
.category-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background-color: #f1f3f5;
  color: #212529;
  font-size: 0.8125rem;
  font-weight: 500;
  text-decoration: none;
  border: 1px solid #dee2e6;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.category-pill:hover {
  background-color: #e7f1ff;
  border-color: var(--color-link-blue);
  color: var(--color-link-blue);
}
.detailsPageHeader .breadcrumb-wrapper {
  flex: 1 1;
  min-width: 0;
}

.detailsPageHeader .header-actions {
  white-space: nowrap;
}
@media (max-width: 768px) {
  .detailsPageHeader {
    transform: none;
    margin-bottom: 0;
  }
}
.details-header-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

@media (max-width: 768px) {
  .details-header-actions {
    justify-content: flex-start;
  }

  .details-header-actions > * {
    flex: 0 0 auto;
  }
}
@media (max-width: 768px) {
  .card-body select.float-end {
    height: 32px;
    padding: 4px 8px;
    margin-top: 2px;
  }
}
.date-divider-line {
  flex-grow: 1;
  border: none;
  border-top: 1px solid var(--color-primary-orange);
  margin: 0 10px;
}
.search-input-outline {
  border: 1px solid var(--color-primary-orange);
}
.metrics-filter-select {
  background-color: #fff9f5;
  color: #333;
  border-color: var(--color-primary-orange);
  appearance: none;
  padding-right: 2rem;
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1rem auto;
  height: calc(2.25rem + 2px);
  line-height: 1.5;
}
.btn-preview-orange {
	background-color: var(--color-primary-orange);
	border-color: var(--color-primary-orange);
	color: var(--color-white);
}
.badge-required {
  background-color: rgba(220, 53, 69, 0.15);
  color: var(--color-primary-orange);
  border-radius: 12px;
  font-weight: 600;
  padding: 5px 10px;
  font-size: 13px;
}
/* ---------- Login (matches SSO) ---------- */
.login-page {
  --lg-navy: #142335;
  --lg-gold: #d3a66c;
  --lg-gold-light: #f0c58c;
  --lg-ink: #18283d;
  --lg-muted: #61718a;
  --lg-line: #d6dfed;

  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter, "Segoe UI", Arial, sans-serif;
  letter-spacing: normal;
  background: radial-gradient(ellipse at 53% 55%, #20364d 0%, var(--lg-navy) 68%);
  overflow-y: auto;
}

.login-shell {
  width: min(1200px, 70vw);
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: clamp(40px, 6vw, 100px);
  padding: clamp(16px, 3vh, 48px) clamp(24px, 5vw, 80px);
  margin: auto;
}

/* ---- Left hero ---- */
.login-hero {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.login-hero-logo {
  display: block;
  width: auto;
  max-width: 100%;
  max-height: 20vh;
  height: auto;
  margin: 0 auto;
}
.login-hero-rule {
  width: 20%;
  height: 5px;
  border-radius: 6px;
  background: var(--lg-gold-light);
  margin: 0 15px 3vh 15px;
}

.login-portals {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
}
.login-portal {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 1.6vh 22px;
  border: 1px solid rgba(255, 255, 255, .12);
  border-radius: 12px;
  background: rgba(255, 255, 255, .04);
  color: #fff;
  text-decoration: none;
  transition: border-color .2s, background .2s;
}
.login-portal:hover {
  border-color: rgba(211, 166, 108, .5);
  background: rgba(255, 255, 255, .06);
  color: #fff;
}
.login-portal.active {
  border-color: var(--lg-gold);
  background: rgba(211, 166, 108, .08);
}

.login-portal-icon { flex: 0 0 auto; display: flex; }
.login-portal-icon svg,
.login-portal-arrow {
  width: 26px;
  height: 26px;
  fill: none;
  stroke: var(--lg-gold);
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.login-portal-arrow { width: 18px; height: 18px; }
.login-portal-text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.login-portal-text strong { font-size: 17px; font-weight: 600; }
.login-portal-text small { font-size: 14px; color: #b9c4d2; }

.login-partners {
  margin-top: 4vh;
  width: 100%;
}
.login-partners-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  color: #f4f5f7;
  letter-spacing: .24em;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  white-space: nowrap;
  margin-bottom: 2vh;
}
.login-partners-label::before,
.login-partners-label::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #cbd4df;
  opacity: .85;
}
.login-partners-strip {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  justify-items: center;
  gap: 12px;
  width: 100%;
  min-height: 0;
  padding: 2vh 24px;
  background: #fff;
  border-radius: 24px;
}
.login-partners-strip img {
  display: block;
  width: 100%;
  max-width: 120px;
  height: clamp(36px, 5vh, 55px);
  object-fit: contain;
}

/* ---- Right card ---- */
.login-card {
  background: #fff;
  color: var(--lg-ink);
  border-radius: 17px;
  padding: clamp(20px, 4vh, 48px);
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 18px 55px rgba(0, 0, 0, .09);
}
.login-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 2vh;
}
.login-logo {
  width: 9vh;
  height: 9vh;
  object-fit: contain;
  margin: 0 auto 1.2vh;
}
.login-brand h1 {
  font-size: clamp(26px, 4vh, 38px);
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -.035em;
  color: var(--lg-ink);
  margin: 0;
}
.login-brand p {
  font-size: 16px;
  color: var(--lg-muted);
  margin: 8px 0 0;
}
.login-portal-pill {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 1vh 18px;
    margin-bottom: 2vh;
    background: #f5f7fb;
    border: 1px solid var(--lg-line);
    border-radius: 9px;
}
.login-portal-pill .login-portal-icon svg {
  width: 24px;
  height: 24px;
  stroke: #1c3453;
}
.login-portal-pill .login-portal-text strong { color: var(--lg-ink); font-size: 16px; }
.login-portal-pill .login-portal-text small { color: var(--lg-muted); font-size: 14px; }
 .login-field {
    position: relative;
    margin-bottom: 26px;
}
.login-field label {
    display: block;
    color: #566780;
    font-size: 17px;
    font-weight: 600;
    margin: 0 0 5px;
}

.login-input-wrap { position: relative; }
.login-input-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  fill: none;
  stroke: #1c3453;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
  pointer-events: none;
}

.login-input {
  display: block;
  width: 100%;
  height: clamp(44px, 6vh, 60px);
  padding: 0 54px 0 60px;
  font: inherit;
  font-size: 16px;
  color: var(--lg-ink);
  background: #fff;
  border: 1px solid var(--lg-line);
  border-radius: 9px;
  outline: none;
}
.login-input::placeholder { color: #70809a; }
.login-input:focus {
  border-color: var(--lg-gold);
  box-shadow: 0 0 0 3px rgba(211, 166, 108, .17);
}
.login-input.is-invalid { border-color: #e5484d; }
.login-error { 
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 3px;
  font-size: 13px;
  color: #e5484d; 
}

.login-forgot {
  display: block;
  width: fit-content;          /* new: link is only as wide as the text */
  margin: -0.5vh 0 3vh auto;   /* was -0.5vh 0 3vh; auto pushes it right */
  color: #b77c37;
  font-size: 17px;
  text-decoration: none;
}
.login-forgot:hover { color: #b77c37; text-decoration: underline; }

/* beats .default-btn-color's !important */
.login-btn.default-btn-color {
  width: 100% !important;
  height: clamp(46px, 6.5vh, 64px);
  border: 0;
  border-radius: 9px;
  background-color: var(--lg-gold) !important;
  border-color: var(--lg-gold) !important;
  color: var(--lg-ink) !important;
  font-size: 20px;
  font-weight: 700;
  transition: background .2s;
}
.login-btn.default-btn-color:hover { background-color: #e0b57d !important; }

/* ---- Tablet ---- */
@media (max-width: 1000px) {
  .login-shell { width: 100%; gap: 32px; padding: 24px 36px; }
  .login-card { padding: 28px; min-height: 0; }
  .login-partners-strip { gap: 8px; padding: 2vh 14px; }
  .login-partners-strip img { max-width: 105px; height: 44px; }
}

/* ---- Mobile: fit everything in one screen ---- */
@media (max-width: 768px) {
  .login-page {
    height: auto;
    min-height: 100dvh;
    align-items: stretch;
    overflow-y: auto;
  }

  .login-shell {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    max-width: 570px;
    height: auto;
    min-height: auto;
    margin: 0 auto;
    padding: 2vh 16px 4vh;
    gap: 2vh;
    display: flex;
    flex-direction: column;
  }

  /* Hero */
  .login-hero {
    display: contents;
  }

  .login-hero-logo { width: 70%; max-height: 6vh; margin: 0 auto 0px; order: 1; }
  .login-hero-rule { height: 3px; margin: 0 0 1.5vh; display: none;}

  .login-portals { gap: 2vh; order: 2; display:none; }
  .login-portal { padding: 1vh 14px; gap: 12px; }
  .login-portal-icon svg { width: 20px; height: 20px; }
  .login-portal-text strong { font-size: 14px; }
  .login-portal-text small { display: none; }   /* hide descriptions */

  .login-partners {
    order: 4;
    margin-top: 1vh;
  }
  .login-partners-label { font-size: 10px; gap: 8px; margin-bottom: 1vh; }
  .login-partners-strip {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 6px;
    padding: 1vh 10px;
    border-radius: 14px;
  }
  .login-partners-strip img { height: 3.5vh; max-width: 60px; }

  /* Card */
  .login-card {
    order: 3;
    padding: 10% 20px;
    justify-content: flex-start;
    min-height: 0;
    overflow-y: visible;
    margin-top:0;
  }
  .login-logo { width: 5vh; height: 5vh; margin-bottom: 0.8vh;  }
  .login-brand { margin-bottom: 1.5vh; }
  .login-brand h1 { font-size: 3.2vh; }
  .login-brand p { font-size: 13px; margin-top: 4px; }

  .login-portal-pill { display: none; }   /* already shown as active portal above */

  .login-field { margin-bottom: 2.5vh; }
  .login-field label { font-size: 14px; margin-bottom: 3px; }
  .login-input { height: 5.5vh; min-height: 40px; font-size: 16px; }
  .login-forgot { font-size: 14px; margin: -1vh 0 1.5vh auto; }
  .login-btn.default-btn-color { height: 5.5vh; min-height: 42px; font-size: 16px; }
}
.login-shell--single {
  grid-template-columns: 1fr;
  max-width: 520px;
}

.login-success {
  background: #f0f9f4;
  border: 1px solid #b7e4c7;
  color: #1e6b3f;
  border-radius: 9px;
  padding: 14px 18px;
  font-size: 15px;
  text-align: center;
}

.login-back {
  display: block;
  text-align: center;
  margin-top: 2.5vh;
  color: #b77c37;
  font-size: 16px;
  text-decoration: none;
}
.login-back:hover { color: #b77c37; text-decoration: underline; }
.login-shell--single .login-brand h1 {
  font-size: clamp(22px, 3vh, 28px);
}

.login-shell--single .login-brand p {
  font-size: 14px;
}

.login-page--light {
  background: #fff;
}

.login-page--light .login-card {
  border: 1px solid var(--lg-line);
}
.login-alert {
  background: #fdecec;
  border: 1px solid #f5c2c7;
  color: #b42318;
  border-radius: 9px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 2vh;
}

.login-hint {
  font-size: 13px;
  color: var(--lg-muted);
  margin: -0.5vh 0 2.5vh;
}
.login-hint ul {
  margin: 4px 0 0;
  padding-left: 18px;
  columns: 2;
}

.login-input[readonly] {
  background: #f5f7fb;
  color: var(--lg-muted);
}
.login-page--top {
  align-items: flex-start;
}

.login-page--top .login-shell {
  margin: -1vh auto auto;
}

.login-shell--single .login-field {
  margin-bottom: clamp(35px, 3.8vh, 38px);   /* was 24–30px */
}
.login-shell--single .login-btn.default-btn-color {
  height: 36px;
  font-size: 14px;
  width: 30% !important;
  display: block;
  margin: 0 auto;             /* centers it */
}
@media (max-width: 768px) {
  .login-page--reset {
    align-items: center;
  }
  .login-page--reset .login-shell {
    margin: auto;
  }
  .login-page--reset .login-logo {
  display: block;
}
}
.login-subtitle {
  display: none;
}
@media (max-width: 768px) {
  .login-subtitle {
    display: block;
  }
}
.copy-btn {
  padding: 0;
  color: var(--color-primary-green);
  text-decoration: none;
  vertical-align: baseline;
}
.copy-btn:hover,
.copy-btn:focus {
  color: var(--color-primary-green);
  opacity: 0.8;
}

.wvgo-link-btn {
  padding: 0;
  color: var(--color-teal);
  text-decoration: none;
  font-weight: normal;
}
.wvgo-link-btn:hover {
  color: var(--color-teal-hover);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;;EAE3B,sFAAsF;EACtF,2BAA2B;;EAE3B,uFAAuF;EACvF,+CAA+C;;EAE/C,0BAA0B;EAC1B,2BAA2B;EAC3B,sCAAsC;EACtC,kDAAkD;AACpD,2CAA2C;AAC3C,8CAA8C;AAC9C,oDAAoD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,UAAU;AACZ;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,uDAAuD;EACvD,mDAAmD;EACnD,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;;GAGG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,YAAY;AACd;;;;AAIA;EACE,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;EAC1C,iCAAiC;;EAEjC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gCAAgC;EAChC,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sDAAsD;EACtD,YAAY;AACd;AACA,iCAAiC,oCAAoC,CAAC;;AAEtE,wBAAwB,sDAAsD,CAAC;;AAE/E;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,WAAW,EAAE,eAAe;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C,EAAE,yBAAyB;AACxE;;AAEA;EACE,oCAAoC,EAAE,4BAA4B;EAClE,WAAW,EAAE,4BAA4B;AAC3C;;AAEA;EACE,oCAAoC,EAAE,wBAAwB;EAC9D,WAAW,EAAE,6BAA6B;AAC5C;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,qCAAqC,EAAE,6BAA6B;EACpE,oCAAoC,EAAE,iCAAiC;AACzE;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,YAAY;AACd;AACA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB,IAAI,kCAAkC;EACtD,cAAc,MAAM,+BAA+B;EACnD,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;;EAEE,wBAAwB,EAAE,yBAAyB;AACrD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,wDAAwD;EACxD,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC;8CAC4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iDAAiD;EACjD,cAAc;AAChB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;CACC,6CAA6C;CAC7C,yCAAyC;CACzC,yBAAyB;AAC1B;AACA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,sBAAsB;EACtB,+EAA+E;EAC/E,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,sDAAsD;EACtD,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA,qBAAqB,cAAc,EAAE,aAAa,EAAE;AACpD;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,4BAA4B,eAAe,EAAE,gBAAgB,EAAE;AAC/D,2BAA2B,eAAe,EAAE,cAAc,EAAE;;AAE5D;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA,+CAA+C,oBAAoB,EAAE,eAAe,EAAE;AACtF,8CAA8C,sBAAsB,EAAE,eAAe,EAAE;CACtF;IACG,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,oBAAoB,kBAAkB,EAAE;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;AACA,4BAA4B,cAAc,EAAE;AAC5C;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;AACA,0BAA0B,qBAAqB,EAAE;AACjD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB,WAAW,0CAA0C;EACvE,yBAAyB,IAAI,2CAA2C;EACxE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,sBAAsB,cAAc,EAAE,0BAA0B,EAAE;;AAElE,0CAA0C;AAC1C;EACE,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,qCAAqC,oCAAoC,EAAE;;AAE3E,qBAAqB;AACrB;EACE,eAAe,WAAW,EAAE,SAAS,EAAE,kBAAkB,EAAE;EAC3D,cAAc,aAAa,EAAE,aAAa,EAAE;EAC5C,wBAAwB,QAAQ,EAAE,iBAAiB,EAAE;EACrD,4BAA4B,gBAAgB,EAAE,YAAY,EAAE;AAC9D;;AAEA,mDAAmD;AACnD;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,QAAQ;IACR,aAAa;IACb,sBAAsB;EACxB;;EAEA,SAAS;EACT;IACE,iBAAiB;EACnB;;EAEA,mBAAmB,UAAU,EAAE,eAAe,EAAE,kBAAkB,EAAE,QAAQ,EAAE;EAC9E,mBAAmB,WAAW,EAAE,iBAAiB,EAAE,aAAa,CAAC;;EAEjE,iBAAiB,QAAQ,EAAE,QAAQ,EAAE,YAAY,EAAE;EACnD,gBAAgB,iBAAiB,EAAE,SAAS,EAAE;EAC9C,yBAAyB,WAAW,EAAE,YAAY,EAAE;EACpD,4BAA4B,eAAe,EAAE;EAC7C,2BAA2B,aAAa,EAAE,IAAI,sBAAsB;;EAEpE;IACE,QAAQ;IACR,eAAe;EACjB;EACA,wBAAwB,eAAe,EAAE,QAAQ,EAAE,kBAAkB,EAAE;EACvE;IACE,gDAAgD;IAChD,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;EACrB;EACA,4BAA4B,aAAa,EAAE,eAAe,EAAE;;EAE5D,SAAS;EACT;IACE,QAAQ;IACR,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;EACA,cAAc,UAAU,EAAE,WAAW,EAAE,oBAAoB,GAAG;EAC9D,eAAe,oBAAoB,EAAE;EACrC,kBAAkB,gBAAgB,EAAE;EACpC,iBAAiB,eAAe,EAAE,eAAe,EAAE;;EAEnD,qBAAqB,aAAa,EAAE,IAAI,yCAAyC;;EAEjF,eAAe,oBAAoB,EAAE;EACrC,qBAAqB,eAAe,EAAE,kBAAkB,EAAE;EAC1D,eAAe,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE;EACjE,gBAAgB,eAAe,EAAE,yBAAyB,EAAE;EAC5D,+BAA+B,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnF;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,oBAAoB,cAAc,EAAE,0BAA0B,EAAE;AAChE;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC,IAAI,gBAAgB;AAC7D;AACA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,cAAc,cAAc,eAAe;AAC7C;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;EACA,cAAc;AAChB;AACA;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,UAAU;EACV,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;;EAEE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[":root {\r\n  --color-primary-orange: #0E1A2B;\r\n  --color-primary-green: #d1ac72;\r\n  --color-text-dark: #1e2530;\r\n  --color-text-body: #4c5258;\r\n  --color-white: #fff;\r\n  --color-danger: #fd3550;\r\n  --color-info-blue: #037de2;\r\n  --color-link-blue: #0d6efd;\r\n  --color-teal: #0a7674;\r\n  --color-teal-hover: #0d9d9a;\r\n  --color-border-light: #ddd;\r\n  --color-bg-page: #f8f9fb;\r\n  --color-bg-panel: #faf7f2;\r\n  --color-bg-hover: #f8f9fa;\r\n  --color-icon-muted: #6c757d;\r\n  --color-dark-slate: #313a46;\r\n\r\n  /* merged: nearly identical to text-dark (#1e2530 vs #1a2332), now shares one source */\r\n  --color-sidebar-bg: #0E1A2B;\r\n\r\n  /* merged: nearly identical to dark-slate (#313a46 vs #2d3748), now shares one source */\r\n  --color-sidebar-border: var(--color-dark-slate);\r\n\r\n  --color-menu-text: #cbd5e1;\r\n  --color-menu-label: #b0afaf;\r\n  --color-icon-slate: var(--color-white);\r\n  --color-menu-hover-bg: var(--color-sidebar-border);\r\n--color-menu-hover-text: var(--color-white);\r\n--color-menu-active-bg: var(--color-text-dark);\r\n--color-menu-active-text: var(--color-primary-green);\r\n  --color-white-a50: #ffffff50;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: var(--color-white);\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\nbody {\r\n  background: var(--color-bg-page);\r\n  font-family: Roboto, sans-serif;\r\n  font-size: 14px;\r\n  color: var(--color-text-body);\r\n  letter-spacing: .5px;\r\n  overflow-x: hidden;\r\n}\r\n\r\nhtml {\r\n  overflow: hidden;\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100vh;\r\n  position: relative;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.edit {\r\n  margin-right: 5px;\r\n}\r\n\r\n.main {\r\n  width: 100%;\r\n  height: calc(100% - 70px);\r\n  margin-top: 45px;\r\n  margin-bottom: 20px;\r\n  margin-left: 290px;\r\n  padding: 1.5rem 1.5rem 0.7rem 1.5rem;\r\n  overflow: auto;\r\n}\r\n\r\n.wrapper.toggled .main {\r\n  margin-left: 70px;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .main{\r\n    margin-left:0px !important;\r\n  }\r\n}\r\n\r\n.wrapper.toggled .topbar {\r\n  left: 70px;\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .topbar{\r\n    left:0px !important;\r\n  }\r\n}\r\n\r\n.default-btn-color {\r\n  background-color: var(--color-primary-green) !important;\r\n  border-color: var(--color-primary-green) !important;\r\n  color: var(--color-text-dark) !important;\r\n  font-weight: 600;\r\n  font-size: 0.8rem;\r\n  \r\n}\r\n\r\n/* .btn-primary {\r\n  background-color: var(--color-primary-green) !important;\r\n\tborder-color: var(--color-primary-green) !important;\r\n} */\r\n\r\n.error-text {\r\n  color: var(--color-danger);\r\n}\r\n\r\n.modal-title {\r\n  font-weight: bold;\r\n  font-size: 1.25em;\r\n}\r\n\r\n.form-control {\r\n  font-size: 1em;\r\n}\r\n\r\n.title-heading {\r\n  font-size: 20px;\r\n  margin-top: 20px;\r\n  padding-bottom: 5px;\r\n  border-bottom: 1px solid #ccc;\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n}\r\n\r\n.datepicker input[readonly] {\r\n  background-color: var(--color-border-light);\r\n}\r\n\r\n.add-btn-icon {\r\n  color: var(--color-primary-green);\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.edit-btn-icon {\r\n  color: var(--color-info-blue);\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.delete-btn-icon {\r\n  color: var(--color-danger);\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\ndt {\r\n  margin-bottom: .5rem;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  color: black;\r\n}\r\n\r\n\r\n\r\n.top-tab {\r\n  border: none;\r\n  background-color: rgb(238, 234, 234);\r\n  margin: 1px 1px 0px 1px;\r\n  position: relative;\r\n  z-index: 8;\r\n  padding: 5px 20px;\r\n  border-top: 1px solid rgba(0, 0, 0, .125);\r\n  border-right: 1px solid rgba(0, 0, 0, .125);\r\n  border-left: 1px solid rgba(0, 0, 0, .125);\r\n  border-radius: 0.25rem .25rem 0 0;\r\n\r\n  transform: translate(0, 1px);\r\n}\r\n\r\n.top-tab.selected {\r\n  background-color: var(--color-white);\r\n}\r\n\r\n.trackerInfo {\r\n  padding: 10px;\r\n  margin: 20px 0px;\r\n  border-radius: 5px;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.trackerInfo h6 {\r\n  font-weight: bold;\r\n  margin: 5px 0px 20px 0px;\r\n}\r\n\r\n.formPage .row .col-md-6 {\r\n  margin-top: 1.5rem\r\n}\r\n\r\n.role-permissions-row .col label {\r\n  margin-top: 6px;\r\n  font-size: 1.1rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.role-permissions-row {\r\n  padding: 7px 0 7px 0;\r\n  /* border-bottom: 1px solid #00000050; */\r\n}\r\n\r\n.detailsPageHeader {\r\n  position: sticky;\r\n  top: 0;\r\n  background: var(--color-bg-page);\r\n  z-index: 9;\r\n  padding-top: 15px;\r\n  transform: translate(0px, -1.5rem);\r\n  margin-bottom: -1.5rem;\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .default-btn-color {\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\ndl.row {\r\n  margin-bottom: .3rem;\r\n}\r\n\r\n.redirectLink {\r\n  color: var(--color-text-dark);\r\n  text-decoration: none;\r\n}\r\n.redirectLink:hover{\r\n  color:var(--color-primary-orange);\r\n}\r\n\r\n.custom-table-view{\r\n  height: 400px;\r\n  overflow: auto;\r\n}\r\n.custom-table{\r\n  padding: 5px;\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n}\r\n.table>:not(:first-child){\r\n  border-top: none !important;\r\n}\r\n.custom-table td, .custom-table th{\r\n  border: 1px solid var(--color-border-light) !important;\r\n  padding: 8px;\r\n}\r\n.custom-table tr:nth-child(even){background-color: #f2f2f2 !important;}\r\n\r\n.custom-table tr:hover {background-color: var(--color-border-light) !important;}\r\n\r\n.custom-table th {\r\n  padding-top: 12px;\r\n  padding-bottom: 12px;\r\n  text-align: left;\r\n  background-color:var(--color-primary-green) !important;\r\n  color: var(--color-white);\r\n}\r\n\r\n.custom-table span{\r\n  text-transform:capitalize;\r\n}\r\n\r\n.cutImage{\r\n  display: block;\r\n  margin: 0px auto;\r\n  width: 100%;\r\n  /* width: 250px; */\r\n}\r\n\r\n.sampleFile{\r\n  position: absolute;\r\n  right: 50px;\r\n}\r\n\r\n#download-content .viewHeader {\r\n  font-size: 2.5rem !important;\r\n}\r\n\r\n.custom-orange-table td,\r\n.custom-orange-table th,\r\n.custom-orange-table tr,\r\n.custom-orange-table thead,\r\n.custom-orange-table tbody {\r\n  border-color:var(--color-primary-orange) !important;\r\n}\r\n\r\n.no-border {\r\n  border-color: transparent !important;\r\n}\r\n\r\n.custom-btn {\r\n  float: right;\r\n  font-size: 0.9rem;\r\n  margin-bottom: 10px;;\r\n}\r\n\r\n.custom-header {\r\n  background-color: #D1D1E8; /* Change to your desired color */\r\n  color: #000; /* Text color */\r\n  font-weight: bold;\r\n  text-align: center;\r\n  font-size: 0.85rem;\r\n  border: 1px solid var(--color-border-light); /* Optional: Add border */\r\n}\r\n\r\n.dash-odd-row {\r\n  background-color: #eff5f8 !important; /* Light blue for odd rows */\r\n  color: #333; /* Text color for odd rows */\r\n}\r\n\r\n.dash-even-row {\r\n  background-color: var(--color-white); /* White for even rows */\r\n  color: #333; /* Text color for even rows */\r\n}\r\n\r\n.statTile-txt\r\n{\r\n  color:#000 !important;\r\n  font-size: 1rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.msg-btn, .msg-btn:hover {\r\n  background-color: transparent !important;\r\n  border-color: transparent !important;\r\n  color: var(--color-primary-orange);\r\n  font-size: 2rem;\r\n}\r\n\r\n.dropdown-custom .dropdown-item:hover {\r\n  background-color: #444444\t !important; /* Highlight color on hover */\r\n  color: rgb(214, 212, 212) !important; /* Optional: make text readable */\r\n}\r\n.notification-preview * {\r\n  margin: 0;\r\n  padding: 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n.notification-preview p {\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.notification-preview img {\r\n  display: block;\r\n  /* vertical-align: middle; */\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n/* Make the actual Quill container resizable */\r\n.editor-container .ql-container {\r\n  min-height: 180px;\r\n  max-height: 600px;\r\n  resize: vertical;   /* native expand/collapse handle */\r\n  overflow: auto;     /* scrollbar only when needed */\r\n  border: 1px solid var(--color-border-light);\r\n  background: var(--color-white);\r\n}\r\n\r\n/* Let editor grow inside */\r\n.editor-container .ql-editor {\r\n  min-height: 150px;\r\n  height: auto;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Keep images responsive inside */\r\n.editor-container .ql-editor img {\r\n  display: block;\r\n  max-width: 100%;\r\n  height: auto;\r\n  margin: 0;\r\n}\r\n\r\n/* Keep heading flush to the left */\r\n.notification-heading {\r\n  text-align: center;\r\n  color:#000;  \r\n  margin-bottom: 6px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Indent content slightly to the right */\r\n.notification-preview {\r\n  padding-left: 20px; \r\n}\r\n\r\n/* Fine-tune inner content */\r\n.notification-preview p,\r\n.notification-preview div {\r\n  margin: 2px 0 !important; /* reduce vertical gaps */\r\n}\r\n\r\n.notification-preview img,\r\n.notification-preview video {\r\n  margin-top: 4px;\r\n}\r\n\r\n.preview-btn-color {\r\n  background-color: var(--color-primary-orange) !important;\r\n  border-color: var(--color-primary-orange) !important;\r\n  color: var(--color-white) !important;\r\n}\r\n\r\n/* date alignment issue fix */\r\n.datepicker .react-datepicker-wrapper {\r\n  width: 100%;\r\n}\r\n\r\n/* Ticketing sys */\r\n.ticketing-link {\r\n  background: var(--color-teal);\r\n  color: var(--color-white);\r\n  padding: 3px 12px;\r\n  border-radius: 5px;\r\n  border: none;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  box-shadow: 0 2px 8px rgba(10, 118, 116, 0.3);\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  /* position: relative; */\r\n}\r\n\r\n.ticketing-link:hover {\r\n  background: var(--color-teal-hover);\r\n  box-shadow: 0 4px 20px rgba(10, 118, 116, 0.5), \r\n              0 0 20px rgba(10, 118, 116, 0.3);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.question-tabs{\r\n  border: 1px solid var(--color-primary-orange);\r\n  border-radius: 4px;\r\n  color: #000;\r\n  transition: all 0.1s ease;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.question-tabs-selected{\r\n  background-color: var(--color-primary-orange);\r\n  color: var(--color-white);\r\n  box-shadow: none !important;\r\n}\r\n\r\n.question-tabs-selected:hover {\r\n  color: var(--color-white);\r\n}\r\n\r\n.question-tabs:hover {\r\n  border-color: var(--color-primary-orange);\r\n  background-color: #fff7ed;\r\n  color: #000;\r\n}\r\n.category-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 6px 12px;\r\n  border-radius: 999px;\r\n  background-color: #f1f3f5;\r\n  color: #212529;\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n  border: 1px solid #dee2e6;\r\n  transition: background-color 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.category-pill:hover {\r\n  background-color: #e7f1ff;\r\n  border-color: var(--color-link-blue);\r\n  color: var(--color-link-blue);\r\n}\r\n.detailsPageHeader .breadcrumb-wrapper {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.detailsPageHeader .header-actions {\r\n  white-space: nowrap;\r\n}\r\n@media (max-width: 768px) {\r\n  .detailsPageHeader {\r\n    transform: none;\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n.details-header-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .details-header-actions {\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .details-header-actions > * {\r\n    flex: 0 0 auto;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .card-body select.float-end {\r\n    height: 32px;\r\n    padding: 4px 8px;\r\n    margin-top: 2px;\r\n  }\r\n}\r\n.date-divider-line {\r\n  flex-grow: 1;\r\n  border: none;\r\n  border-top: 1px solid var(--color-primary-orange);\r\n  margin: 0 10px;\r\n}\r\n.search-input-outline {\r\n  border: 1px solid var(--color-primary-orange);\r\n}\r\n.metrics-filter-select {\r\n  background-color: #fff9f5;\r\n  color: #333;\r\n  border-color: var(--color-primary-orange);\r\n  appearance: none;\r\n  padding-right: 2rem;\r\n  background-repeat: no-repeat;\r\n  background-position: right 0.75rem center;\r\n  background-size: 1rem auto;\r\n  height: calc(2.25rem + 2px);\r\n  line-height: 1.5;\r\n}\r\n.btn-preview-orange {\r\n\tbackground-color: var(--color-primary-orange);\r\n\tborder-color: var(--color-primary-orange);\r\n\tcolor: var(--color-white);\r\n}\r\n.badge-required {\r\n  background-color: rgba(220, 53, 69, 0.15);\r\n  color: var(--color-primary-orange);\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  padding: 5px 10px;\r\n  font-size: 13px;\r\n}\r\n/* ---------- Login (matches SSO) ---------- */\r\n.login-page {\r\n  --lg-navy: #142335;\r\n  --lg-gold: #d3a66c;\r\n  --lg-gold-light: #f0c58c;\r\n  --lg-ink: #18283d;\r\n  --lg-muted: #61718a;\r\n  --lg-line: #d6dfed;\r\n\r\n  height: 100vh;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-family: Inter, \"Segoe UI\", Arial, sans-serif;\r\n  letter-spacing: normal;\r\n  background: radial-gradient(ellipse at 53% 55%, #20364d 0%, var(--lg-navy) 68%);\r\n  overflow-y: auto;\r\n}\r\n\r\n.login-shell {\r\n  width: min(1200px, 70vw);\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  align-items: center;\r\n  gap: clamp(40px, 6vw, 100px);\r\n  padding: clamp(16px, 3vh, 48px) clamp(24px, 5vw, 80px);\r\n  margin: auto;\r\n}\r\n\r\n/* ---- Left hero ---- */\r\n.login-hero {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n.login-hero-logo {\r\n  display: block;\r\n  width: auto;\r\n  max-width: 100%;\r\n  max-height: 20vh;\r\n  height: auto;\r\n  margin: 0 auto;\r\n}\r\n.login-hero-rule {\r\n  width: 20%;\r\n  height: 5px;\r\n  border-radius: 6px;\r\n  background: var(--lg-gold-light);\r\n  margin: 0 15px 3vh 15px;\r\n}\r\n\r\n.login-portals {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  width: 100%;\r\n}\r\n.login-portal {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  padding: 1.6vh 22px;\r\n  border: 1px solid rgba(255, 255, 255, .12);\r\n  border-radius: 12px;\r\n  background: rgba(255, 255, 255, .04);\r\n  color: #fff;\r\n  text-decoration: none;\r\n  transition: border-color .2s, background .2s;\r\n}\r\n.login-portal:hover {\r\n  border-color: rgba(211, 166, 108, .5);\r\n  background: rgba(255, 255, 255, .06);\r\n  color: #fff;\r\n}\r\n.login-portal.active {\r\n  border-color: var(--lg-gold);\r\n  background: rgba(211, 166, 108, .08);\r\n}\r\n\r\n.login-portal-icon { flex: 0 0 auto; display: flex; }\r\n.login-portal-icon svg,\r\n.login-portal-arrow {\r\n  width: 26px;\r\n  height: 26px;\r\n  fill: none;\r\n  stroke: var(--lg-gold);\r\n  stroke-width: 1.6;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n}\r\n.login-portal-arrow { width: 18px; height: 18px; }\r\n.login-portal-text {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n.login-portal-text strong { font-size: 17px; font-weight: 600; }\r\n.login-portal-text small { font-size: 14px; color: #b9c4d2; }\r\n\r\n.login-partners {\r\n  margin-top: 4vh;\r\n  width: 100%;\r\n}\r\n.login-partners-label {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 18px;\r\n  color: #f4f5f7;\r\n  letter-spacing: .24em;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n  margin-bottom: 2vh;\r\n}\r\n.login-partners-label::before,\r\n.login-partners-label::after {\r\n  content: \"\";\r\n  flex: 1;\r\n  height: 1px;\r\n  background: #cbd4df;\r\n  opacity: .85;\r\n}\r\n.login-partners-strip {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, minmax(0, 1fr));\r\n  align-items: center;\r\n  justify-items: center;\r\n  gap: 12px;\r\n  width: 100%;\r\n  min-height: 0;\r\n  padding: 2vh 24px;\r\n  background: #fff;\r\n  border-radius: 24px;\r\n}\r\n.login-partners-strip img {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 120px;\r\n  height: clamp(36px, 5vh, 55px);\r\n  object-fit: contain;\r\n}\r\n\r\n/* ---- Right card ---- */\r\n.login-card {\r\n  background: #fff;\r\n  color: var(--lg-ink);\r\n  border-radius: 17px;\r\n  padding: clamp(20px, 4vh, 48px);\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  box-shadow: 0 18px 55px rgba(0, 0, 0, .09);\r\n}\r\n.login-brand {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    margin-bottom: 2vh;\r\n}\r\n.login-logo {\r\n  width: 9vh;\r\n  height: 9vh;\r\n  object-fit: contain;\r\n  margin: 0 auto 1.2vh;\r\n}\r\n.login-brand h1 {\r\n  font-size: clamp(26px, 4vh, 38px);\r\n  line-height: 1.2;\r\n  font-weight: 700;\r\n  letter-spacing: -.035em;\r\n  color: var(--lg-ink);\r\n  margin: 0;\r\n}\r\n.login-brand p {\r\n  font-size: 16px;\r\n  color: var(--lg-muted);\r\n  margin: 8px 0 0;\r\n}\r\n.login-portal-pill {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n    padding: 1vh 18px;\r\n    margin-bottom: 2vh;\r\n    background: #f5f7fb;\r\n    border: 1px solid var(--lg-line);\r\n    border-radius: 9px;\r\n}\r\n.login-portal-pill .login-portal-icon svg {\r\n  width: 24px;\r\n  height: 24px;\r\n  stroke: #1c3453;\r\n}\r\n.login-portal-pill .login-portal-text strong { color: var(--lg-ink); font-size: 16px; }\r\n.login-portal-pill .login-portal-text small { color: var(--lg-muted); font-size: 14px; }\r\n .login-field {\r\n    position: relative;\r\n    margin-bottom: 26px;\r\n}\r\n.login-field label {\r\n    display: block;\r\n    color: #566780;\r\n    font-size: 17px;\r\n    font-weight: 600;\r\n    margin: 0 0 5px;\r\n}\r\n\r\n.login-input-wrap { position: relative; }\r\n.login-input-icon {\r\n  position: absolute;\r\n  left: 18px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 24px;\r\n  height: 24px;\r\n  fill: none;\r\n  stroke: #1c3453;\r\n  stroke-width: 1.8;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n  pointer-events: none;\r\n}\r\n\r\n.login-input {\r\n  display: block;\r\n  width: 100%;\r\n  height: clamp(44px, 6vh, 60px);\r\n  padding: 0 54px 0 60px;\r\n  font: inherit;\r\n  font-size: 16px;\r\n  color: var(--lg-ink);\r\n  background: #fff;\r\n  border: 1px solid var(--lg-line);\r\n  border-radius: 9px;\r\n  outline: none;\r\n}\r\n.login-input::placeholder { color: #70809a; }\r\n.login-input:focus {\r\n  border-color: var(--lg-gold);\r\n  box-shadow: 0 0 0 3px rgba(211, 166, 108, .17);\r\n}\r\n.login-input.is-invalid { border-color: #e5484d; }\r\n.login-error { \r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  margin-top: 3px;\r\n  font-size: 13px;\r\n  color: #e5484d; \r\n}\r\n\r\n.login-forgot {\r\n  display: block;\r\n  width: fit-content;          /* new: link is only as wide as the text */\r\n  margin: -0.5vh 0 3vh auto;   /* was -0.5vh 0 3vh; auto pushes it right */\r\n  color: #b77c37;\r\n  font-size: 17px;\r\n  text-decoration: none;\r\n}\r\n.login-forgot:hover { color: #b77c37; text-decoration: underline; }\r\n\r\n/* beats .default-btn-color's !important */\r\n.login-btn.default-btn-color {\r\n  width: 100% !important;\r\n  height: clamp(46px, 6.5vh, 64px);\r\n  border: 0;\r\n  border-radius: 9px;\r\n  background-color: var(--lg-gold) !important;\r\n  border-color: var(--lg-gold) !important;\r\n  color: var(--lg-ink) !important;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  transition: background .2s;\r\n}\r\n.login-btn.default-btn-color:hover { background-color: #e0b57d !important; }\r\n\r\n/* ---- Tablet ---- */\r\n@media (max-width: 1000px) {\r\n  .login-shell { width: 100%; gap: 32px; padding: 24px 36px; }\r\n  .login-card { padding: 28px; min-height: 0; }\r\n  .login-partners-strip { gap: 8px; padding: 2vh 14px; }\r\n  .login-partners-strip img { max-width: 105px; height: 44px; }\r\n}\r\n\r\n/* ---- Mobile: fit everything in one screen ---- */\r\n@media (max-width: 768px) {\r\n  .login-page {\r\n    height: auto;\r\n    min-height: 100dvh;\r\n    align-items: stretch;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .login-shell {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: auto 1fr;\r\n    max-width: 570px;\r\n    height: auto;\r\n    min-height: auto;\r\n    margin: 0 auto;\r\n    padding: 2vh 16px 4vh;\r\n    gap: 2vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  /* Hero */\r\n  .login-hero {\r\n    display: contents;\r\n  }\r\n\r\n  .login-hero-logo { width: 70%; max-height: 6vh; margin: 0 auto 0px; order: 1; }\r\n  .login-hero-rule { height: 3px; margin: 0 0 1.5vh; display: none;}\r\n\r\n  .login-portals { gap: 2vh; order: 2; display:none; }\r\n  .login-portal { padding: 1vh 14px; gap: 12px; }\r\n  .login-portal-icon svg { width: 20px; height: 20px; }\r\n  .login-portal-text strong { font-size: 14px; }\r\n  .login-portal-text small { display: none; }   /* hide descriptions */\r\n\r\n  .login-partners {\r\n    order: 4;\r\n    margin-top: 1vh;\r\n  }\r\n  .login-partners-label { font-size: 10px; gap: 8px; margin-bottom: 1vh; }\r\n  .login-partners-strip {\r\n    grid-template-columns: repeat(5, minmax(0, 1fr));\r\n    gap: 6px;\r\n    padding: 1vh 10px;\r\n    border-radius: 14px;\r\n  }\r\n  .login-partners-strip img { height: 3.5vh; max-width: 60px; }\r\n\r\n  /* Card */\r\n  .login-card {\r\n    order: 3;\r\n    padding: 10% 20px;\r\n    justify-content: flex-start;\r\n    min-height: 0;\r\n    overflow-y: visible;\r\n    margin-top:0;\r\n  }\r\n  .login-logo { width: 5vh; height: 5vh; margin-bottom: 0.8vh;  }\r\n  .login-brand { margin-bottom: 1.5vh; }\r\n  .login-brand h1 { font-size: 3.2vh; }\r\n  .login-brand p { font-size: 13px; margin-top: 4px; }\r\n\r\n  .login-portal-pill { display: none; }   /* already shown as active portal above */\r\n\r\n  .login-field { margin-bottom: 2.5vh; }\r\n  .login-field label { font-size: 14px; margin-bottom: 3px; }\r\n  .login-input { height: 5.5vh; min-height: 40px; font-size: 16px; }\r\n  .login-forgot { font-size: 14px; margin: -1vh 0 1.5vh auto; }\r\n  .login-btn.default-btn-color { height: 5.5vh; min-height: 42px; font-size: 16px; }\r\n}\r\n.login-shell--single {\r\n  grid-template-columns: 1fr;\r\n  max-width: 520px;\r\n}\r\n\r\n.login-success {\r\n  background: #f0f9f4;\r\n  border: 1px solid #b7e4c7;\r\n  color: #1e6b3f;\r\n  border-radius: 9px;\r\n  padding: 14px 18px;\r\n  font-size: 15px;\r\n  text-align: center;\r\n}\r\n\r\n.login-back {\r\n  display: block;\r\n  text-align: center;\r\n  margin-top: 2.5vh;\r\n  color: #b77c37;\r\n  font-size: 16px;\r\n  text-decoration: none;\r\n}\r\n.login-back:hover { color: #b77c37; text-decoration: underline; }\r\n.login-shell--single .login-brand h1 {\r\n  font-size: clamp(22px, 3vh, 28px);\r\n}\r\n\r\n.login-shell--single .login-brand p {\r\n  font-size: 14px;\r\n}\r\n\r\n.login-page--light {\r\n  background: #fff;\r\n}\r\n\r\n.login-page--light .login-card {\r\n  border: 1px solid var(--lg-line);\r\n}\r\n.login-alert {\r\n  background: #fdecec;\r\n  border: 1px solid #f5c2c7;\r\n  color: #b42318;\r\n  border-radius: 9px;\r\n  padding: 12px 16px;\r\n  font-size: 14px;\r\n  margin-bottom: 2vh;\r\n}\r\n\r\n.login-hint {\r\n  font-size: 13px;\r\n  color: var(--lg-muted);\r\n  margin: -0.5vh 0 2.5vh;\r\n}\r\n.login-hint ul {\r\n  margin: 4px 0 0;\r\n  padding-left: 18px;\r\n  columns: 2;\r\n}\r\n\r\n.login-input[readonly] {\r\n  background: #f5f7fb;\r\n  color: var(--lg-muted);\r\n}\r\n.login-page--top {\r\n  align-items: flex-start;\r\n}\r\n\r\n.login-page--top .login-shell {\r\n  margin: -1vh auto auto;\r\n}\r\n\r\n.login-shell--single .login-field {\r\n  margin-bottom: clamp(35px, 3.8vh, 38px);   /* was 24–30px */\r\n}\r\n.login-shell--single .login-btn.default-btn-color {\r\n  height: 36px;\r\n  font-size: 14px;\r\n  width: 30% !important;\r\n  display: block;\r\n  margin: 0 auto;             /* centers it */\r\n}\r\n@media (max-width: 768px) {\r\n  .login-page--reset {\r\n    align-items: center;\r\n  }\r\n  .login-page--reset .login-shell {\r\n    margin: auto;\r\n  }\r\n  .login-page--reset .login-logo {\r\n  display: block;\r\n}\r\n}\r\n.login-subtitle {\r\n  display: none;\r\n}\r\n@media (max-width: 768px) {\r\n  .login-subtitle {\r\n    display: block;\r\n  }\r\n}\r\n.copy-btn {\r\n  padding: 0;\r\n  color: var(--color-primary-green);\r\n  text-decoration: none;\r\n  vertical-align: baseline;\r\n}\r\n.copy-btn:hover,\r\n.copy-btn:focus {\r\n  color: var(--color-primary-green);\r\n  opacity: 0.8;\r\n}\r\n\r\n.wvgo-link-btn {\r\n  padding: 0;\r\n  color: var(--color-teal);\r\n  text-decoration: none;\r\n  font-weight: normal;\r\n}\r\n.wvgo-link-btn:hover {\r\n  color: var(--color-teal-hover);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
